import { Version } from '@angular/core';

/** Current version of simple ui. */
export const VERSION = new Version('0.0.0-PLACEHOLDER');
